module.exports = __webpack_public_path__ + "img/iPhone-5-placeholder.90b41ed1.svg";